import RightArrowIcon from "@/assets/colorable/right_arrow.svg?react";
import useContentIcons from "@/hooks/useContentIcons";
import ContentPurchaseButton from "@/pages/plans/ContentPurchaseButton";
import {Can} from "@/permissions";
import {useCarouselStore, type TCarouselMedia} from "@/store/carousel";
import {getContentPermalink, getContentPublishedDate} from "@/utils/mediaUtils";
import dayjs from "dayjs";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const DefaultCarouselFooter: FC<{content: TCarouselMedia}> = ({content}) => {
  const {t} = useTranslation("common");
  const contentIcons = useContentIcons("ALL");
  const variant = useCarouselStore(state => state.variant);
  const ContentIcon = contentIcons[content.instagram_media?.media_product_type!]?.Icon;
  const permalink = getContentPermalink({media: content.instagram_media});

  return (
    <div className="flex w-full min-w-fit flex-col items-center justify-center">
      <Can I="download" a="Content" passThrough>
        {allowed => (
          <div
            onClick={e => e.stopPropagation()}
            className="border-neutral-black flex flex-col items-center justify-between gap-3 rounded-lg border bg-black p-1 text-sm text-white sm:flex-row sm:px-5 sm:py-3 md:w-full">
            {allowed && (
              <ContentPurchaseButton
                containerClassName="sm:w-full"
                contents={[content]}
                className="w-full px-5"
                buyoutsPerContent={content.buyoutsPerContent}
              />
            )}
            {variant !== "default" && variant !== "gallery" && variant !== "rating" && variant !== "social_feed" && (
              <div className="flex flex-col items-center gap-2">
                <div
                  className={
                    allowed
                      ? "flex w-1/2 shrink-0 items-center justify-center gap-1"
                      : "flex h-10 w-full shrink-0 items-center justify-center gap-1"
                  }>
                  {ContentIcon && <ContentIcon className="size-4 shrink-0" />}
                  <span className="sm:whitespace-nowrap">
                    {t("uploadedTime", {
                      uploadDate: dayjs(getContentPublishedDate({media: content.instagram_media})).format("DD.MM.YYYY"),
                    })}
                  </span>
                </div>
                {!!permalink && (
                  <button
                    onClick={() => window.open(permalink, "_blank")}
                    className="flex items-center gap-2 text-white transition-colors duration-150 hover:text-white/80">
                    <span className="text-xs">
                      {t("view_on_platform", {
                        platform: t(content.instagram_media?.media_product_type === "TIKTOK" ? "tiktok" : "instagram"),
                      })}
                    </span>
                    <RightArrowIcon className="size-3 shrink-0" />
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </Can>
    </div>
  );
};

export default DefaultCarouselFooter;
